import { render, staticRenderFns } from "./todo-column.vue?vue&type=template&id=a1258fbc&scoped=true&"
import script from "./todo-column.vue?vue&type=script&lang=js&"
export * from "./todo-column.vue?vue&type=script&lang=js&"
import style0 from "./todo-column.vue?vue&type=style&index=0&id=a1258fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1258fbc",
  null
  
)

export default component.exports